import { render, staticRenderFns } from "./ExOrgPositionHeader.vue?vue&type=template&id=3b8aa9c1"
import script from "./ExOrgPositionHeader.vue?vue&type=script&lang=js"
export * from "./ExOrgPositionHeader.vue?vue&type=script&lang=js"
import style0 from "./ExOrgPositionHeader.vue?vue&type=style&index=0&id=3b8aa9c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports